import { cdnFileUrl } from './utils';

const STORAGE_KEY = 'teri_play_history';
const MAX_ITEMS = 100;

function normalizeItem(raw) {
    return {
        videoId: Number(raw.videoId),
        videoName: String(raw.videoName || ''),
        videoPath: String(raw.videoPath || ''),
        videoImg: String(raw.videoImg || ''),
        authorName: String(raw.authorName || ''),
        watchedAt: Number(raw.watchedAt) || Date.now(),
    };
}

export function readPlayHistory() {
    try {
        const s = localStorage.getItem(STORAGE_KEY);
        if (!s) return [];
        const a = JSON.parse(s);
        if (!Array.isArray(a)) return [];
        return a.map(normalizeItem).filter((x) => Number.isFinite(x.videoId) && x.videoId > 0);
    } catch {
        return [];
    }
}

function writePlayHistory(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}

/**
 * 追加一条观看记录：同 videoId 会移到最前并更新时间
 */
export function appendToPlayHistory(entry) {
    const item = normalizeItem({ ...entry, watchedAt: Date.now() });
    let list = readPlayHistory();
    list = list.filter((x) => x.videoId !== item.videoId);
    list.unshift(item);
    if (list.length > MAX_ITEMS) {
        list = list.slice(0, MAX_ITEMS);
    }
    writePlayHistory(list);
    return list;
}

export function removeFromPlayHistory(videoId) {
    const id = Number(videoId);
    const list = readPlayHistory().filter((x) => x.videoId !== id);
    writePlayHistory(list);
    return list;
}

export function clearPlayHistory() {
    writePlayHistory([]);
}

export function playHistoryCoverUrl(relativePath) {
    return cdnFileUrl(relativePath);
}

/** 优先用缩略图 videoImg，与首页/搜索卡片一致；旧数据无 videoImg 时回退 videoPath */
export function playHistoryItemCoverUrl(item) {
    if (!item) return '';
    const path = item.videoImg || item.videoPath || '';
    return playHistoryCoverUrl(path);
}

export function formatPlayHistoryTime(ts) {
    const t = Number(ts);
    if (!Number.isFinite(t)) return '';
    const d = Date.now() - t;
    if (d < 60 * 1000) return '刚刚';
    if (d < 60 * 60 * 1000) return `${Math.floor(d / (60 * 1000))}分钟前`;
    if (d < 24 * 60 * 60 * 1000) return `${Math.floor(d / (60 * 60 * 1000))}小时前`;
    const date = new Date(t);
    const now = new Date();
    const yday = new Date(now);
    yday.setDate(yday.getDate() - 1);
    if (date.toDateString() === yday.toDateString()) return '昨天';
    const pad = (n) => (n < 10 ? `0${n}` : `${n}`);
    return `${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}
